import {TSchedule} from "@COMPONENTS/product/types";
import * as style from "@COMPONENTS/style/detailpackage/itinerarychorusM";
import IconButton from "@FRAMEWORK/ui/mobile/button/IconButton";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {getScheduleSEO} from "@FRAMEWORK/utils/seo";
import {eventDetailSSR} from "@QUERIES/prdt/event/useEventDetail";
import {goodsDetailSSR} from "@QUERIES/prdt/goods/useGoodsDetail";
import {goodsImageSSR} from "@QUERIES/prdt/goods/useGoodsImage";
import {goodsVideoSSR} from "@QUERIES/prdt/goods/useGoodsVideo";
import {GetServerSidePropsContext} from "next/types";

/** component */
import useOverlay from "@/hooks/common/useOverlay";
import SharePopup from "@COMPONENTS/common/modal/share/Mobile";
import DetailHeader from "@COMPONENTS/product/pages/detailPackage/mobile/detailHeader";
import DetailPrice from "@COMPONENTS/product/pages/detailPackage/mobile/detailPrice";
import DetailSchedule from "@COMPONENTS/product/pages/detailPackage/mobile/detailSchedule";
import DetailScheduleSummary from "@COMPONENTS/product/pages/detailPackage/mobile/detailScheduleSummary";
import ScheduleManager from "@COMPONENTS/product/pages/schedule/mobile/ScheduleManager";

const Page = (props: TSchedule) => {
	const [open] = useOverlay();
	/** 대리점정보 로직 추가해야함.. */
	const share = () => {
		open(overlay => (
			<SharePopup {...overlay} baseUrl={`${location.origin}${location.pathname}`} parameter={location.search} />
		));
	};

	return (
		<style.Wrap>
			<style.HeaderWrap>
				<h3>여행 일정표</h3>
				<IconButton type="button" icon="share" onClick={share}>
					<span>공유하기</span>
				</IconButton>
			</style.HeaderWrap>
			<ScheduleManager {...props} />
			{/* 행사이름 ,블릿 ,행사 이미지, 픽토그램 , 우수상품 등.. */}
			<DetailHeader {...props} useScheduleView={true} />
			{/* 여행 주요 일정 */}
			<DetailScheduleSummary {...props} />
			{/* 상품가 */}
			<DetailPrice {...props} usePointBtn={false} />
			{/* 일정탭 */}
			<DetailSchedule {...props} useScheduleView={true} />
			<style.AccountNotice>
				노랑풍선의 &apos;예금주&apos; 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여
				당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선 고객센터로
				문의하거나 신고하여 주시기 바랍니다.
			</style.AccountNotice>
		</style.Wrap>
	);
};

export default Page;

const getServerSidePropsSSR = async (evCd: string) => {
	const goodsCd = evCd.substring(0, 7);

	const eventDetailPromise = await eventDetailSSR(evCd);
	const eventDetail = eventDetailPromise.data.body || null;

	const goodsDetailPromise = await goodsDetailSSR(goodsCd);
	const goodsDetail = goodsDetailPromise.data.body || null;

	const goodsImagePromise = await goodsImageSSR(goodsCd);
	const goodsImage = goodsImagePromise.data.body || [];

	const goodsVideoPromise = await goodsVideoSSR(goodsCd);
	const goodsVideo = goodsVideoPromise.data.body || [];
	return {
		goodsImage,
		goodsVideo,
		eventDetail,
		goodsDetail,
	};
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
	const {query} = ctx;
	const evCd = query?.evCd as string | undefined;

	if (!evCd || typeof evCd !== "string") {
		return {
			redirect: {destination: publicRuntimeConfig.ENV_PORTAL_URL, permanent: false},
		};
	}

	try {
		const data = await getServerSidePropsSSR(evCd);
		const seo = await getScheduleSEO("evCd", evCd);
		return {
			props: {
				query: {...query},
				...seo,
				...data,
			},
		};
	} catch {
		return {
			redirect: {destination: publicRuntimeConfig.ENV_PORTAL_URL, permanent: false},
		};
	}
}
